(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["i-am-not-a-circle"] = factory();
	else
		root["i-am-not-a-circle"] = factory();
})(this, function() {
return 